import { combineReducers } from 'redux';
import { userSettingsSlice } from './settings/userSettingsSlice';

const usersResourceReducer = combineReducers({
  settings: userSettingsSlice.reducer,
});

export default usersResourceReducer;
